module.exports = __webpack_public_path__ + "static/media/icon.08df1ea7.png";